// extracted by mini-css-extract-plugin
export default {"containerScore":"style_containerScore__OOMWS","score":"style_score__kNSP-","button":"style_button__TWbBm"};